// Sets the browser tab's title for as long as a page is mounted, restoring
// whatever was there when the page unmounts.
//
// The app has no per-page title mechanism -- every page has always shown the
// one static <title> in public/index.html. The Salish Sea page is the first
// public URL that isn't the site itself, so it wants its own; this is the
// smallest thing that gives it one without pulling in a head manager.
//
// The restore matters because this is a SPA: without it, navigating away
// would leave the previous page's title on a different page. Restoring the
// value captured at mount (rather than a hard-coded default) keeps that true
// however many pages start doing this.

import { useEffect } from 'react';

export function useDocumentTitle(title) {
  useEffect(() => {
    if (typeof document === 'undefined' || !title) {
      return undefined;
    }
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
